// Social Media Share

const SocialShare = () => {
    // Creates small window popups for social media sharing, except for email
    // $(".social__link:not(.social__link--email)").click(function(ev) {
    //     var url = $(this).attr("href");

    //     // open popup
    //     window.open(
    //         url,
    //         "Social",
    //         "width=500,height=400,resizable=yes,scrollbars=yes,titlebar=yes"
    //     );

    //     ev.preventDefault();
    //     return false;
    // });

    const socialShareItems = document.querySelectorAll(".social__link.popup");

    if (socialShareItems) {
        socialShareItems.forEach(socialShareItem => {
            socialShareItem.addEventListener("click", e => {
                e.preventDefault();
                const url = socialShareItem.href;
                // open popup
                window.open(
                    url,
                    "Social",
                    "width=500,height=400,resizable=yes,scrollbars=yes,titlebar=yes"
                );

                return false;
            });
        });
    }

    const mailLinks = document.querySelectorAll('.social-link[href^="mailto"]');

    if (mailLinks) {
        mailLinks.forEach(mailLink => {
            mailLink.addEventListener("click", e => e.preventDefault());
        });
    }
};

export default SocialShare;
